module.exports = __webpack_public_path__ + "img/public-main-img-01.b0ea78e3.jpg";